import React from 'react';
import PropTypes from 'prop-types';

/**
 * Create a header which can highlight a set of DropdownItems.
 *
 * @class DropdownHeader
 * @displayName DropdownHeader (Web)
 * @public
 */
export default function DropdownHeader({ children }) {
  return (
    <div
      role='heading'
      aria-level='1'
      className='dropdown-header title small'>
      {children}
    </div>
  );
}

/**
 * Children should be provided.
 *
 * @enum {Object} propTypes
 * @public
 */
DropdownHeader.propTypes = {
  /** Contents of a dropdown header */
  children: PropTypes.node.isRequired
};
